import { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { getResponseData } from "../../../../../reactQuery/response";

export function normalizeFeedBoard(boardName) {
  return getResponseData(boardName, boardName?.data?.responseData ?? boardName ?? null);
}

export function useFeedBoardMeta(boardName, cardId) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const board = useMemo(() => normalizeFeedBoard(boardName), [boardName]);
  const boardMeta = useMemo(
    () => ({
      board,
      boardId: board?.board_id ?? null,
      boardKey: board?.key ?? "",
      boardKeyDisplay: board?.key?.toUpperCase() ?? "",
      boardName: board?.board_name ?? "",
      ownerId: board?.owner_user_id ?? null,
      workflowId: board?.workflow_id ?? null,
    }),
    [board]
  );

  const actions = useMemo(
    () => ({
      openBoard: () => {
        if (boardMeta.boardId) {
          navigate(`/board/${boardMeta.boardId}`);
        }
      },
      openCard: (event) => {
        if (!boardMeta.boardKey || !cardId) {
          return;
        }

        const isModifierPressed = event?.metaKey || event?.ctrlKey || event?.shiftKey;
        const url = `/feeds/${boardMeta.boardKey}/${boardMeta.boardKey}-${cardId}?${searchParams.toString()}`;

        if (isModifierPressed) {
          window.open(url, "_blank");
          event.stopPropagation();
          return;
        }

        navigate(url);
      },
    }),
    [boardMeta.boardId, boardMeta.boardKey, cardId, navigate, searchParams]
  );

  return {
    ...boardMeta,
    ...actions,
  };
}
